<template>
    <div class="py-3">
        <div class="container">
            <TravelExpenseReportTabs :linksDisabled=false :expenseReportID=expenseReportID ref="nav"></TravelExpenseReportTabs>
            <div class="row">
                <div class="col-md-12">
                    <div v-if="!loading && expenseReportStatusTypeId > 1" style="text-align:center; color:red;">Changes will not be saved unless Save button is clicked</div>
                    <h4 style="font-weight:900; margin-bottom:0px;">Lodging <b-spinner v-if="loading" variant="primary" label="Spinning"></b-spinner></h4>
                    <div class="my-1" style="margin-top:0px;">{{expenseReportStatusTypeName}}</div>
                    <ValidationAlertComponent v-if="!loading" :expenseReportID="expenseReportID" :area="'lodging'" ref="validationAlert"></ValidationAlertComponent>
                    <form v-if="!loading" class="" v-on:submit.prevent>
                        <div class="form-group"></div>
                        <label>
                            Per Diem <font-awesome-icon style="margin-left:5px;" v-b-popover.hover="lodingPerDiemIcon" icon="info-circle" />
                            <br>
                        </label>
                        <div class="form-group">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th scope="col">Location</th>
                                        <th scope="col">Month</th>
                                        <th scope="col">Year</th>
                                        <th scope="col">Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="ls.domesticLocation" v-for="(ls,lSIndex) in lodgeLocationSummary">
                                        <td><span v-if="ls.domesticLocation.city">{{ls.domesticLocation.city}},&nbsp;</span> <span v-if="ls.domesticLocation.state">{{ls.domesticLocation.state}}</span><span v-if="ls.domesticLocation.country">&nbsp;{{ls.domesticLocation.county}}</span></td>
                                        <td>{{ls.month}}</td>
                                        <td>{{ls.year}}</td>
                                        <td>{{ls.amount}}</td>
                                    </tr>
                                    <tr v-if="ls.foreignLocation" v-for="(ls,lSIndex) in lodgeLocationSummary">
                                        <td><span v-if="ls.foreignLocation.city">{{ls.foreignLocation.city}},&nbsp;</span> <span v-if="ls.foreignLocation.country">{{ls.foreignLocation.country}}</span></td>
                                        <td>{{ls.month}}</td>
                                        <td>{{ls.year}}</td>
                                        <td>{{ls.amount}}</td>
                                    </tr>
                                    <tr v-if="ls.otherDomesticLocation" v-for="(ls,lSIndex) in lodgeLocationSummary">
                                        <td><span v-if="ls.otherDomesticLocation.city">{{ls.otherDomesticLocation.city}},&nbsp;</span> <span v-if="ls.otherDomesticLocation.country">{{ls.otherDomesticLocation.country}}</span></td>
                                        <td>{{ls.month}}</td>
                                        <td>{{ls.year}}</td>
                                        <td>{{ls.amount}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div v-for="(h,hIndex) in hotels">
                            <div style="max-width:75px;">
                                Hotel {{hIndex + 1}}
                                <button type="button" class="close" aria-label="Close" @click="showRemovalModal(ItemRemoveType.Lodge,h,hIndex)">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>


                            <!-- test area -->
                            <!-- TODO gotta move this onto another element below -->
                            <!--<div v-for="(hD,hDIndex) in enumerateDaysBetweenDates(h.startDate,h.endDate,h)">
    </div>-->
                            <!-- test area -->

                            <div class="form-group"><label>Hotel Name<br></label><input v-model="h.hotelName" type="text" class="form-control w-25" placeholder="Hotel Name"></div>
                            <div class="form-group">
                                <label>Check in</label>
                                <datepicker :typeable="false" :format="'MMMM dd yyyy'" input-class="form-control w-25" :use-utc=true v-model="h.startDate" @input="enumerateDaysBetweenDates(h.startDate,h.endDate,h)" :disabled-dates="disabledCheckinDates"></datepicker>
                                <!--<input v-model="h.startDate" @input="enumerateDaysBetweenDates(h.startDate,h.endDate,h)" type="date" class="form-control w-25" required="required"> <small class="form-text text-muted"></small>-->
                            </div>
                            <div class="form-group">
                                <label>Check out</label>
                                <datepicker :typeable="false" :format="'MMMM dd yyyy'" input-class="form-control w-25" :use-utc=true v-model="h.endDate" @input="enumerateDaysBetweenDates(h.startDate,h.endDate,h)" :disabled-dates="disabledCheckoutDates"></datepicker>
                                <!--<input v-model="h.endDate" @input="enumerateDaysBetweenDates(h.startDate,h.endDate,h)" type="date" class="form-control w-25" required="required"> <small class="form-text text-muted"></small>-->
                            </div>
                            <div v-if="h.hotelDayDates.length > 0" style="overflow-x: auto;" class="mb-2">
                                <table class="table">
                                    <thead>

                                        <tr>
                                            <th scope="col" class="copypreviousday"> Copy previous day</th>
                                            <th scope="col" v-for="(hdd,hddIndex) in h.hotelDayDates"><button v-if="hddIndex != 0" type="button" class="btn btn-info btn-sm" @click="copyLastDayBaseTaxValue(h,hdd,hddIndex)">Copy</button></th>
                                        </tr>
                                    </thead>
                                    <thead>
                                        <tr>
                                            <th scope="col"> </th>
                                            <th scope="col" v-for="(hdd,hddIndex) in h.hotelDayDates" :key="hdd.vueJSUniqueID"><div class="personalText" v-bind:class="{'showPersonalText':hdd.personalDay}">personal day<br /></div>{{hdd.hotelDate | formatDate}}</th>
                                            <th v-if="h.hotelDayDates" scope="col">Sub-Total</th>
                                            <th v-if="h.hotelDayDates" scope="col">Adj</th>
                                            <th v-if="h.hotelDayDates" scope="col">Total</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <th scope="row">Base</th>
                                            <td class="td-updated" v-for="(hdd,hddIndex) in h.hotelDayDates" :key="hdd.vueJSUniqueID" v-bind:class="{'offday':hdd.personalDay}">
                                                <input v-model="hdd.base" @input="updateHotelDay(h,hdd)" class="remove-input-border" v-bind:class="{'offday':hdd.personalDay, 'errortext': hdd.baseWarning }" type="number" @focus="$event.target.select()" />
                                            </td>
                                            <td class="td-updated" v-if="h.hotelDayDates">{{h.baseSubTotal | currency}}</td>
                                            <td class="td-updated" v-if="h.hotelDayDates">({{h.baseAdjustment  | currency}})</td>
                                            <!-- ADD ADJUSTMENT FOR BASE HERE -->
                                        </tr>
                                        <tr>
                                            <th scope="row"><font-awesome-icon style="margin-left:5px;" v-b-popover.hover="'Only include nightly room tax amounts. Parking charges, food and associated taxes, and other ancillary charges should be excluded from these values. Mandatory resort fees should be included within the Other section.'" icon="info-circle" /> Taxes</th>
                                            <td class="td-updated" v-for="(hdd,hddIndex) in h.hotelDayDates" :key="hdd.vueJSUniqueID" v-bind:class="{'offday':hdd.personalDay}">
                                                <input v-model="hdd.taxes" class="remove-input-border" v-bind:class="{'offday':hdd.personalDay, 'errortext': hdd.baseWarning }" @input="updateHotelDay(h,hdd)" type="number" @focus="$event.target.select()" />
                                            </td>
                                            <td class="td-updated" v-if="h.hotelDayDates">{{h.taxesSubTotal  | currency}}</td>
                                            <td class="td-updated" v-if="h.hotelDayDates">({{h.taxesAdjustment  | currency}})</td>
                                            <!-- ADD ADJUSTMENT FOR TAXES HERE -->
                                        </tr>
                                        <tr class="total">
                                            <th scope="row">Total</th>
                                            <td class="td-updated" v-bind:class="{'offday':hdd.personalDay}" v-for="(hdd,hddIndex) in h.hotelDayDates" :key="hdd.vueJSUniqueID">{{hdd.total  | currency}}</td>
                                            <td class="td-updated" v-if="h.hotelDayDates">{{h.subTotal  | currency}}</td>
                                            <td class="td-updated" v-if="h.hotelDayDates">({{h.adjustmentTotal  | currency}})</td>
                                            <td class="td-updated" v-if="h.hotelDayDates">{{h.total  | currency}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <!--TODO Implement attachment-->
                                <div class="form-group">
                                    <button class="btn btn-sm btn-secondary" type="button" @click="$bvModal.show('businessAmountAttachmentsModal'+ hIndex)">Attach Lodging Receipt</button>
                                    <span style="cursor: pointer">
                                        <div v-for="(baa, baaIndex) in h.attachments">
                                            <span @click="downloadFileInNewWindow(baa)">{{baa.attachmentName}}</span> <span aria-hidden="true" @click="showRemovalModal(ItemRemoveType.LodgeAttachment,hIndex,baaIndex)">&times;</span>
                                        </div>
                                    </span>
                                    <b-modal :id="'businessAmountAttachmentsModal' + hIndex" centered title="Add Receipt" :hide-footer=true>
                                        <AttachmentComponent :expenseReportId="expenseReportID" :attachments="h.attachments" @fileUploadDone="$bvModal.hide('businessAmountAttachmentsModal'+ hIndex)"></AttachmentComponent>
                                    </b-modal>
                                </div>
                            </div>
                            <!-- exceptions -->
                            <div class="list-group pb-2" v-if="h.hotelDayDates.filter(hotelDay => hotelDay.exception == true).length > 0">
                                <a class="list-group-item list-group-item-action list-group-item-danger">
                                    <span class="right-span">Warning</span><span class="warning-span-info">Exception occured for the following dates:</span>
                                </a>
                                <div class="list-group-item">
                                    <div v-for="(hdd, hddIndex) in h.hotelDayDates" style="display:flex;flex-direction:row">
                                        <div v-if="hdd.exceptions[0] && !hdd.personalDay && hdd.exceptions[0].expenseExceptionTypeId == 1" style="display:flex;flex-direction:column">
                                            <span v-if="!hddIndex" style="flex-shrink:1">
                                                <span class="warning-span-info">{{ exceptions[hdd.exceptions[0].expenseExceptionTypeId-1].exceptionText }}</span>
                                            </span>
                                            <div style="display:flex;flex-direction:row">
                                                <span class="right-span" style="flex-basis:2%">
                                                    {{ hdd.hotelDate | formatDate }}
                                                </span>
                                                <span class="form-group right-span" style="flex-shrink:1" v-if="(!h.mergeExceptions && hddIndex) || !hddIndex">
                                                    <select v-bind:class="{'is-invalid': !hdd.exceptions[0].responseValue }"
                                                            @change="updateLodgingAdjustments(h, hdd)"
                                                            v-model="hdd.exceptions[0].responseValue"
                                                            class="form-control w-100 form-control-sm warning-span"
                                                            id="exampleFormControlSelect2">
                                                        <option v-for="option in exceptions.find(x => x.expenseExceptionTypeId == 1).lodgeExceptionTypes"
                                                                :value="option.value">
                                                            {{ option.text }}
                                                        </option>
                                                    </select>
                                                </span>
                                                <span v-if="mutlipleExceptions(h) && !hddIndex" style="flex-shrink:1">
                                                    <b-form-checkbox v-model="h.mergeExceptions" name="merge-checkbox">
                                                        Same exception applies to all dates
                                                    </b-form-checkbox>
                                                </span>
                                            </div>
                                        </div>
                                        <div v-if="hdd.exceptions[0] && !hdd.personalDay && hdd.exceptions[0].expenseExceptionTypeId == 3" style="display:flex;flex-direction:column">
                                            <span v-if="!hddIndex" style="flex-shrink:1">
                                                <span class="warning-span-info">{{ exceptions[hdd.exceptions[0].expenseExceptionTypeId-1].exceptionText }}</span>
                                            </span>
                                            <div style="display:flex;flex-direction:row">
                                                <span class="right-span" style="flex-basis:2%">
                                                    {{ hdd.hotelDate | formatDate }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="!hasExceptionTypes(h, [2, 6])">
                                        <!-- Display attachment when option selected does not equal 'none' -->
                                        <div class="input-group-append">
                                            <button class="btn btn-secondary btn-sm top-bottom-margin" type="button" @click="$bvModal.show(`exceptionAttachmentsModal${hIndex}`)">Attach</button>
                                            <span style="align-self:center">Note - Attachment(s) required to support exception(s) selected.</span>
                                        </div>
                                        <span style="cursor: pointer">
                                            <div v-for="(baa,baaIndex) in firstException(h,hIndex)">
                                                <span @click="downloadFileInNewWindow(baa)">{{baa.attachmentName}}</span> <span aria-hidden="true" @click="firstException(h,hIndex).splice(baaIndex,1)">&times;</span>
                                            </div>
                                        </span>
                                        <b-modal :id="`exceptionAttachmentsModal${hIndex}`" centered title="Add Attachment" :hide-footer=true>
                                            <AttachmentComponent :expenseReportId="expenseReportID" :attachments="firstException(h,hIndex)" @fileUploadDone="$bvModal.hide(`exceptionAttachmentsModal${hIndex}`)"></AttachmentComponent>
                                        </b-modal>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-group">
                            <a class="btn btn-secondary btn-sm btn-text-white" @click="addHotel">Add Hotel</a>
                        </div>

                        <b-form-textarea id="supportingRemark"
                                         v-model="lodging.supportingRemark"
                                         placeholder="Supporting remarks, if needed"
                                         rows="1"
                                         max-rows="3"
                                         style="margin-bottom:15px;">
                        </b-form-textarea>
                        <button type="button" class="btn btn-primary btn-lg" style="margin-bottom:15px;" @click="saveHotel()">Save</button>
                    </form>
                </div>
                <CommentsComponent v-if="!loading  && expenseReportStatusTypeId > 1" :expenseReportID="expenseReportID" :area="'lodging'"></CommentsComponent>
                <div v-if="!loading  && expenseReportStatusTypeId > 1" class="col-md-12">
                    <!-- audit history comp -->
                    <AuditHistoryComponent :expenseReportID="expenseReportID" :area="'lodging'"></AuditHistoryComponent>
                </div>
            </div>
        </div>
        <modal title="Confirm Delete?" :is-small="true" v-if="show_modal_remove" @close="show_modal = false">
            <div class="modal-body">
                Are you sure you want to remove this item?
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" @click="removeItem(itemTypeToRemove, itemToRemove, attachmentToRemove)">Delete</button>
                <button type="button" class="btn btn-primary" @click="show_modal_remove = false">Cancel</button>
            </div>
        </modal>
        <modal title="Save progress?" :is-small="true" v-if="show_modal" @close="show_modal=false">
            <div class="modal-body">
                Save changes to expense report?
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" @click="saveAndContinue(true)">Save</button>
                <button type="button" class="btn btn-primary" @click="saveAndContinue(false)">Cancel</button>
            </div>
        </modal>
    </div>
</template>


<script>
    import Datepicker from 'vuejs-datepicker';
    import TravelExpenseReportTabs from '@/components/TravelExpenseReportTabs.vue'
    import AttachmentComponent from '@/components/AttachmentComponent.vue'
    import AuditHistoryComponent from '@/components/AuditHistoryComponent.vue'
    import CommentsComponent from '@/components/CommentsComponent.vue'
    import LodgeService from '@/services/LodgeService'
    import MealService from '@/services/MealService'
    import DateService from '@/services/DateService'
    import TripProfileService from '@/services/TripProfileService'
    import ValidationAlertComponent from '@/components/ValidationAlertComponent.vue'
    import modal from '@/components/modal.vue'

    export default {
        name: 'lodging',
        components: {
            TravelExpenseReportTabs,
            Datepicker,
            AttachmentComponent,
            AuditHistoryComponent,
            CommentsComponent,
            ValidationAlertComponent,
            modal
        },

        async created() {
            if (this.$route.params.erid) {
                this.loading = true;
                this.expenseReportID = this.$route.params.erid;
                this.lodgeLocationSummary = await LodgeService.getLodgeLocationSummary(this.expenseReportID);
                this.referenceDates = await LodgeService.getReferenceDates(this.expenseReportID)
                this.lodging = await LodgeService.getLodges(this.expenseReportID);
                this.hotels = LodgeService.mapResponseToHotel(this.lodging.lodges,true);
                this.updateAllHotelAllDays();
                let response = await TripProfileService.getExpenseReportStatus(this.expenseReportID);
                this.expenseReportStatusTypeId = response.expenseReportStatusTypeId;
                this.expenseReportStatusTypeName = response.expenseReportStatusTypeName;
                this.loading = false;
                this.hash = this.hashData;
            }
        },
        computed: {
            hashData: function () {
                return JSON.stringify(this.createLodgeRequest());
            }    
        },
        data: function () {
            return {
                lodingPerDiemIcon: {
                    content: `Domestic Per Diem rates apply to base lodging costs only.<br>
                              Other US / Foreign Per Diem rates apply to base lodging costs plus taxes.<br>` ,
                    html: true
                },
                expenseReportStatusTypeId: 1,
                expenseReportStatusTypeName: "",
                show_modal: false,
                loading: true,
                lodging: null,
                supportingRemark: '',
                exceptions: [
                    {
                        exceptionText: 'Actual cost exceeds allowable per diem, please select an exception.',
                        exceptionType: 'select',
                        expenseExceptionTypeId: 1,
                        lodgeExceptionTypes: [
                            {
                                text: 'None (overage will not be reimbursed)',
                                value: 2
                            },
                            {
                                text: 'Work/Event is at the lodging site',
                                value: 3
                            },
                            {
                                text: 'Director affirms that lodging within per diem was not available within reasonable proximity to work/event site',
                                value: 4
                            },
                            {
                                text: 'Approved by funding source',
                                value: 5
                            },
                            {
                                text: 'No hotels available under reasonable circumstances (up to 200% per diem)',
                                value: 6
                            }
                        ]
                    },
                    {
                        exceptionText: "Because you charged expenses on a personal day, please provide exception.",
                        exceptionType: 'attachment',
                        expenseExceptionTypeId: 2,
                        lodgeExceptionTypes: []
                    },
                    {
                        exceptionText: "Per Diem Rate is not valid",
                        exceptionType: 'error',
                        expenseExceptionTypeId: 3,
                        lodgeExceptionTypes: []
                    }
                ],
                referenceDates: null,
                referenceDateDebug: "",
                lodgeLocationSummary: null,
                expenseReportID: null,
                hotels: [],
                hash: null,
                disabledCheckinDates: {
                    customPredictor: (date) => {
                        if (!this.referenceDates || !this.referenceDates.length) {
                            return true;
                        }

                        for (let i = 0; i < this.referenceDates.length; i++) {
                            let datePickerDate = DateService.normalizeDateTime(date);
                            let referenceDate = DateService.normalizeDateTime(this.referenceDates[i].date);
                            if (DateService.normalizeDateTime(referenceDate).isSame(datePickerDate, 'date')) {
                                let dayAfterReferenceDate = DateService.normalizeDateTime(referenceDate).add(1, 'days');
                                let isEndOfTrip = true;
                                for (let h = 0; h < this.referenceDates.length; h++) {
                                    if (dayAfterReferenceDate.isSame(DateService.normalizeDateTime(this.referenceDates[h].date), 'date')) {
                                        isEndOfTrip = false;
                                    }
                                }

                                return isEndOfTrip;
                            }
                        }

                        return true;
                    }
                },
                disabledCheckoutDates: {
                    customPredictor: (date) => {
                        if (!this.referenceDates || !this.referenceDates.length) {
                            return true;
                        }

                        for (let i = 0; i < this.referenceDates.length; i++) {
                            let datePickerDate = DateService.normalizeDateTime(date);
                            let referenceDate = DateService.normalizeDateTime(this.referenceDates[i].date);
                            if (DateService.normalizeDateTime(referenceDate).isSame(datePickerDate, 'date')) {
                                return false;
                            }
                        }

                        return true;
                    }
                },
                show_modal_remove: false,
                itemToRemove: null,
                attachmentToRemove: null,
                itemTypeToRemove: null,
                ItemRemoveType: {
                    Lodge: 0,
                    LodgeAttachment: 1
                }
            }
        },
        methods: {
            firstException(htl, index) {
                return htl.hotelDayDates.find((hdd) => hdd.exception === true).exceptions[0].attachments;
            },
            allExceptions(htl) {
                return htl.hotelDayDates.reduce((exceptions, date) => date.exceptions ? exceptions.concat(date.exceptions) : exceptions, []);
            },
            mutlipleExceptions(htl) {
                return htl.hotelDayDates.reduce((count, date) => date.exceptions ? date.exceptions.length + count : count, 0) > 1;
            },
            anyExceptions(htl) {
                return htl.hotelDayDates.reduce((count, date) => date.exceptions ? date.exceptions.length + count : count, 0) > 0;
            },
            hasExceptionTypes(htl, validValues) {
                let isExceptionType = htl.hotelDayDates.every(function (date) {
                    if (date.exceptions && date.exceptions.length > 0 && date.exceptions[0] !== undefined) {
                        let responseValue = date.exceptions[0].responseValue != null ? Number(date.exceptions[0].responseValue) : null;

                        if (validValues.includes(responseValue)) {
                            return true; 
                        } else if (responseValue === null) {
                            return true;
                        } else {
                            return false;
                        }
                    }
                    return true;
                });

                return isExceptionType;
            },

            removeItem(itemType, index, attachIndex) {
                switch (itemType) {
                    case 0:
                        this.deleteLodge(index, attachIndex);
                        break;
                    case 1:
                        this.removeBusinessAttachment(index, attachIndex);
                        break;
                    default:
                        break;
                }
                this.show_modal_remove = false;
            },
            showRemovalModal(itemType, index, attachIndex) {
                this.itemToRemove = index;
                this.itemTypeToRemove = itemType;
                this.attachmentToRemove = attachIndex;
                this.show_modal_remove = true;
            },
            downloadFileInNewWindow(params) {
                console.log(params)
                let documentType = 'receipts/';
                if (params.attachmentTypeId == 2) {
                    documentType = 'InstitutionalDocuments/'
                }
                this.$http
                    .get(documentType + params.attachmentId + '/Download', {
                        responseType: 'blob',
                        headers: {
                            "Authorization": "Bearer " + this.msal.accessToken
                        }
                    })
                    .then((response) => {
                        const file = new Blob(
                            [response.data],
                            { type: response.headers['content-type'] });
                        const downloadUrl = window.URL.createObjectURL(file);
                        window.open(downloadUrl);
                    })
                    .catch(error => {
                        this.$notify({
                            group: 'errors',
                            type: 'error',
                            title: 'Error',
                            text: error
                        });
                        this.errored = true
                    })
                    .finally(() => this.loading = false)
            },
            updateLodgingAdjustments(hotel, hotelDay) {
                this.$nextTick(() => {
                    this.updateHotelDay(hotel, hotelDay);
                })
            },
            async deleteLodge(lodge, lodgeIndex) {
                console.log('lodgingview.methods.deleteLodge')
                console.log(lodge)
                console.log(lodgeIndex)
                if (lodge.id) {
                    await LodgeService.deleteLodge(lodge.id);
                }
                this.hotels.splice(lodgeIndex, 1);
            },
            removeBusinessAttachment(hotelIndex, businessAttahcmentIndex) {
                if (!this.lodging.lodges[hotelIndex]) {
                    this.hotels[hotelIndex].attachments.splice(businessAttahcmentIndex, 1);
                }
                else {
                    this.lodging.lodges[hotelIndex].attachments.splice(businessAttahcmentIndex, 1);
                }
            },
            isValid() {
                //validation here
                return true;
            },
            createLodgeRequest() {
                let lodgeRequest = LodgeService.createSaveRequest(this.hotels, this.expenseReportID, this.lodging.supportingRemark)
                return lodgeRequest;
            },
            copyLastDayBaseTaxValue(hotel, hdd, hddIndex) {
                console.log('lodgingview.methods.copyLastDayBaseTaxValue')
                if (hddIndex && hddIndex != 0) {
                    hdd.base = hotel.hotelDayDates[hddIndex - 1].base;
                    hdd.taxes = hotel.hotelDayDates[hddIndex - 1].taxes;
                    hdd.total = hotel.hotelDayDates[hddIndex - 1].total;
                    this.updateHotelDay(hotel, hdd);
                }
            },
            async calculateWarnings(hotel, hotelDay) {
                console.log('lodgingview.methods.calculateWarnings')
                let m = this.moment;
                let index = 0;
                let referenceDay = this.referenceDates.filter(function (l,idx) {

                    let referenceDateFormatted = DateService.normalizeDateTime(l.date);
                    let hotelDayFormatted = DateService.normalizeDateTime(hotelDay.hotelDate);
                    const match = m(referenceDateFormatted).isSame(DateService.normalizeDateTime(hotelDayFormatted), 'day');
                    if (match)
                        index = idx;
                    return match;
                })

                //check if over allowed limit
                //check if day is found in trip, if not set warning
                if ((Array.isArray(referenceDay) && referenceDay.length) != true) {
                    hotelDay.baseWarning = true;
                    hotelDay.exception = true
                }
                //check if over amount on day reference is so set warning
                else if (referenceDay[0].domesticLocationId && referenceDay[0].referenceLodge.amount < hotelDay.base || hotelDay.base > 0 && referenceDay[0].personal) {
                    hotelDay.baseWarning = true;
                    hotelDay.exception = true;

                    this.lodgeLocationSummary.forEach((x) => {
                        console.log(x)
                        let monthDiff = m(x.date).diff(hotelDay.hotelDate, "month");
                        if (x.amount == 0 && monthDiff == 0 && referenceDay[0].domesticLocationId) {
                            console.log(m(x.date));
                            //    console.log(m(x.date).startOf("month").diff(hotelDay.hotelDate.startOf("month"), "month"));
                            console.log(hotelDay.hotelDate);
                            //create exception if does not exist
                            if (hotelDay.exceptions && hotelDay.exceptions.length == 0) {
                                hotelDay.exceptions.push(
                                    {
                                        expenseExceptionTypeId: 3,
                                        isSatisfied: false,
                                        responseValue: null,
                                        attachments: []
                                    }
                                )
                            }
                        }
                    })

                    //create exception if does not exist
                    if (hotelDay.exceptions && hotelDay.exceptions.length == 0) {
                        hotelDay.exceptions.push(
                            {
                                expenseExceptionTypeId: 1,
                                isSatisfied: false,
                                responseValue: null,
                                attachments: []
                            }
                        )
                    }
                }
                else if ((referenceDay[0].foreignLocationId || referenceDay[0].otherDomesticLocationId) && referenceDay[0].referenceLodge.amount < (Number(hotelDay.base) + Number(hotelDay.taxes)) || (Number(hotelDay.base) + Number(hotelDay.taxes)) > 0 && referenceDay[0].personal) {
                    hotelDay.baseWarning = true;
                    hotelDay.exception = true;

                    //create exception if does not exist
                    if (hotelDay.exceptions && hotelDay.exceptions.length == 0) {
                        hotelDay.exceptions.push(
                            {
                                expenseExceptionTypeId: 1,
                                isSatisfied: false,
                                responseValue: null,
                                attachments: []
                            }
                        )
                    }
                }
                //assume date exists and its not over
                //clear out any exceptions.
                else {
                    if (hotelDay.exceptions && hotelDay.exceptions.length > 0)
                        for (var i = 0; i < hotelDay.exceptions.length; i++) {
                            if (hotelDay.exceptions[i].id) {
                                await MealService.deleteException(hotelDay.exceptions[i].id);
                            }
                        }
                    hotelDay.baseWarning = false;
                    hotelDay.exception = false;
                    hotelDay.exceptions = [];
                }

                //check if personal day
                if ((Array.isArray(referenceDay) && referenceDay.length) && referenceDay[0].personal == true) {
                    hotelDay.personalDay = true;

                    //create exception if does not exist
                    if (hotelDay.exceptions && hotelDay.exceptions.length == 0) {
                        hotelDay.exceptions.push(
                            {
                                expenseExceptionTypeId: 2,
                                isSatisfied: false,
                                responseValue: null,
                                attachments: []
                            }
                        )
                    }
                }
                else {
                    if (referenceDay[0].personal !== true) {
                        if (this.referenceDates.length > index + 1) {
                            const remaining = this.referenceDates.slice(index + 1);
                            if (remaining[0].personal) {
                                if (!remaining.filter(d => d.personal === false).length)
                                    hotelDay.personalDay = true;

                            }
                        }
                    }
                }
            },

            calculateHotelDaysTotals(hotel) {
                console.log('LodgingView.Methods.calculateHotelDaysTotals')
                let baseSubTotal = _.sumBy(hotel.hotelDayDates, d => Number(d.base));
                let baseOverthreeTimesAdjustment = _.sumBy(hotel.hotelDayDates, d => Number(d.baseOverThreeTimesAdjustment))
                let taxesSubTotal = _.sumBy(hotel.hotelDayDates, d => Number(d.taxes));
                let taxesOverThreeTimesAdjustment = _.sumBy(hotel.hotelDayDates, d => Number(d.taxesOverThreeTimesAdjustment))
                let subTotal = _.sumBy(hotel.hotelDayDates, d => Number(d.total));
                let adjustmentTotal = _.sumBy(hotel.hotelDayDates, d => Number(d.adjustment))


                hotel.baseSubTotal = Number(baseSubTotal)
                hotel.baseAdjustment = Number(baseOverthreeTimesAdjustment)
                hotel.taxesSubTotal = Number(taxesSubTotal)
                hotel.taxesAdjustment = Number(taxesOverThreeTimesAdjustment)
                hotel.subTotal = Number(subTotal).toFixed(2);
                hotel.adjustmentTotal = Number(adjustmentTotal).toFixed(2);
                hotel.total = (Number(subTotal) + Number(adjustmentTotal)).toFixed(2);

            },
            async saveAndContinue(save) {
                let success = false;
                if (save) {
                    success = await this.saveHotel();
                    if (success) {
                        this.navNext();
                    } else {
                        this.navNext(false);
                    }
                }
                else {
                    this.navNext();
                    this.show_modal = false;
                }
            },
            updateHotelDay(hotel, hotelDay) {
                console.log('LodgingView.Methods.updateHotelDay')
                if (!hotelDay.base || isNaN(parseFloat(hotelDay.base)) || hotelDay.base < 0) {
                    hotelDay.base = 0;
                }

                if (!hotelDay.taxes || isNaN(parseFloat(hotelDay.taxes)) || hotelDay.taxes < 0) {
                    hotelDay.taxes = 0;
                }

                //this.$nextTick(() => {
                this.calculateHotelDayTotal(hotel, hotelDay)
                this.calculateHotelDaysTotals(hotel);
                this.calculateWarnings(hotel, hotelDay)
                //})
            },
            calculateHotelDayTotal(hotel, hotelDay) {
                console.log('LodgingView.Methods.calculateHotelDayTotal')
                this.ensureMaxIsNot3TimesReferenceValue(hotelDay);
                hotelDay.adjustment = (Number(hotelDay.baseOverThreeTimesAdjustment) + Number(hotelDay.taxesOverThreeTimesAdjustment)).toFixed(2) // adjustment1 + adjustment 2 .. etc(can add additional adjustments here to total adjustment)
                this.$set(hotelDay, 'total', (Number(hotelDay.base) + Number(hotelDay.taxes)).toFixed(2))
            },
            ensureMaxIsNot3TimesReferenceValue(hotelDay) {
                //find reference day to compare too
                console.log('lodgingView.methods.ensureMaxIsNot3TimesReferenceValue')
                let context = this;
                let referenceDay = this.referenceDates.filter(function (l) {
                    let referenceDateFormatted = DateService.normalizeDateTime(l.date)
                    let lodgeDayFormatted = DateService.normalizeDateTime(hotelDay.hotelDate)
                    return DateService.normalizeDateTime(referenceDateFormatted).isSame(lodgeDayFormatted, 'day');
                })

                //check exception
                console.log('0')

                //if exception response value is false adjust down to 100 percent max.
                if (hotelDay.exceptions[0] != null && hotelDay.exceptions[0].responseValue) {
                    console.log('2')
                    if (hotelDay.exceptions[0].responseValue === 2 || hotelDay.exceptions[0].responseValue === '2') {
                        console.log('3')
                        if (referenceDay[0].domesticLocationId && (hotelDay.base > referenceDay[0].referenceLodge.amount)) {
                            console.log('4')
                            hotelDay.baseOverThreeTimesAdjustment = referenceDay[0].referenceLodge.amount - hotelDay.base;
                            let percentage = ((referenceDay[0].referenceLodge.amount) / hotelDay.base)
                            if (hotelDay.taxes != null && hotelDay.taxes > 0) {
                                let percentageDifference = (Number(hotelDay.taxes) * Number(percentage));
                                hotelDay.taxesOverThreeTimesAdjustment = (Number(hotelDay.taxes) - percentageDifference) * -1;
                                console.log(hotelDay.taxesOverThreeTimesAdjustment)
                            }
                        }
                        else if ((referenceDay[0].foreignLocationId || referenceDay[0].otherDomesticLocationId) && ((Number(hotelDay.base) + Number(hotelDay.taxes)) > referenceDay[0].referenceLodge.amount)) {
                            let baseAndTaxes = Number(hotelDay.base) + Number(hotelDay.taxes);
                            let percentage = (referenceDay[0].referenceLodge.amount / baseAndTaxes)
                            hotelDay.baseOverThreeTimesAdjustment = (Number(hotelDay.base) * percentage) - Number(hotelDay.base);

                            if (hotelDay.taxes != null && hotelDay.taxes > 0) {
                                hotelDay.taxesOverThreeTimesAdjustment = (Number(hotelDay.taxes) * percentage) - Number(hotelDay.taxes);
                            } else {
                                hotelDay.taxesOverThreeTimesAdjustment = 0;
                            }
                        }
                    } else {
                        console.log('5')
                        if (referenceDay[0].domesticLocationId && hotelDay.base > 3 * referenceDay[0].referenceLodge.amount) {
                            console.log('6')
                            hotelDay.baseOverThreeTimesAdjustment = (3 * referenceDay[0].referenceLodge.amount) - hotelDay.base;
                            let percentage = ((3 * referenceDay[0].referenceLodge.amount) / hotelDay.base)
                            if (hotelDay.taxes != null && hotelDay.taxes > 0) {
                                let percentageDifference = (Number(hotelDay.taxes) * Number(percentage));
                                hotelDay.taxesOverThreeTimesAdjustment = (Number(hotelDay.taxes) - percentageDifference) * -1;
                                console.log(hotelDay.taxesOverThreeTimesAdjustment)
                            }
                        }
                        else if ((referenceDay[0].foreignLocationId || referenceDay[0].otherDomesticLocationId) && (Number(hotelDay.base) + Number(hotelDay.taxes)) > 3 * referenceDay[0].referenceLodge.amount) {
                            console.log('6.5')
                            let baseAndTaxes = Number(hotelDay.base) + Number(hotelDay.taxes);
                            let percentage = ((3 * referenceDay[0].referenceLodge.amount) / baseAndTaxes)
                            hotelDay.baseOverThreeTimesAdjustment = (Number(hotelDay.base) * percentage) - Number(hotelDay.base);

                            if (hotelDay.taxes != null && hotelDay.taxes > 0) {
                                hotelDay.taxesOverThreeTimesAdjustment = (Number(hotelDay.taxes) * percentage) - Number(hotelDay.taxes);
                            } else {
                                hotelDay.taxesOverThreeTimesAdjustment = 0;
                            }

                        }
                        else {
                            console.log('7')
                            hotelDay.baseOverThreeTimesAdjustment = 0;
                            hotelDay.taxesOverThreeTimesAdjustment = 0;
                        }
                    }
                }
                else {
                    console.log('8')
                    console.log(referenceDay)


                    //exception does not exist and breakfast value is greater than 300% of reference. Set adjustment to anything above and beyond 300%.
                    if (referenceDay[0].domesticLocationId && (hotelDay.base > 3 * referenceDay[0].referenceLodge.amount)) {
                        console.log('9')
                        hotelDay.baseOverThreeTimesAdjustment = (3 * referenceDay[0].referenceLodge.amount) - hotelDay.base;
                        console.log(hotelDay.baseOverThreeTimesAdjustment)
                        let percentage = ((3 * referenceDay[0].referenceLodge.amount) / hotelDay.base)
                        console.log(percentage)
                        if (hotelDay.taxes != null && hotelDay.taxes > 0) {
                            let percentageDifference = (Number(hotelDay.taxes) * Number(percentage));
                            hotelDay.taxesOverThreeTimesAdjustment = (Number(hotelDay.taxes) - percentageDifference) * -1;
                            console.log(hotelDay.taxesOverThreeTimesAdjustment)
                        }
                    }
                    else if ((referenceDay[0].foreignLocationId || referenceDay[0].otherDomesticLocationId) && (Number(hotelDay.base) + Number(hotelDay.taxes)) > 3 * referenceDay[0].referenceLodge.amount) {
                        console.log('9.5')
                        let baseAndTaxes = Number(hotelDay.base) + Number(hotelDay.taxes);
                        let percentage = ((3 * referenceDay[0].referenceLodge.amount) / baseAndTaxes)
                        hotelDay.baseOverThreeTimesAdjustment = (Number(hotelDay.base) * percentage) - Number(hotelDay.base);

                        if (hotelDay.taxes != null && hotelDay.taxes > 0) {
                            hotelDay.taxesOverThreeTimesAdjustment = (Number(hotelDay.taxes) * percentage) - Number(hotelDay.taxes);
                        } else {
                            hotelDay.taxesOverThreeTimesAdjustment = 0;
                        }

                    }
                    else {
                        console.log('10')
                        hotelDay.baseOverThreeTimesAdjustment = 0;
                        hotelDay.taxesOverThreeTimesAdjustment = 0;
                    }
                }
                //round to 2 decimal places
                hotelDay.baseOverThreeTimesAdjustment = Number(hotelDay.baseOverThreeTimesAdjustment)
                hotelDay.taxesOverThreeTimesAdjustment = Number(hotelDay.taxesOverThreeTimesAdjustment)
            },
            //used on date calendar picker.
            enumerateDaysBetweenDates(startDate, endDate, hotel) {
                console.log('LodgingView.Methods.enumerateDaysBetweenDates')

                if (startDate && endDate) {
                    hotel.hotelDayDates = [];
                    console.log(`startdate ${startDate} and endDate ${endDate}`)
                    let dates = [];
                    //leave in moment date format we can compare below in while loop
                    var currDate = DateService.normalizeDateTime(startDate);
                    //leave in moment date format we can compare below in while loop
                    var lastDate = DateService.normalizeDateTime(endDate);
                    //format currDate to string before push it into collection of dates. This is important the date formats match or union will not work when updateing calendar picker and populate days wrong.
                    dates.push(DateService.normalizeDateTime(currDate).format());
                    while (currDate.add(1, 'days').diff(lastDate, 'day') < 0) {
                        dates.push(DateService.normalizeDateTime(currDate).format());
                    }
                    //format lastDate to string before push it into collection of dates. This is important the date formats match or union will not work when updateing calendar picker and populate days wrong.
                    dates.push(DateService.normalizeDateTime(lastDate).format());

                    let calculatedDates = dates.map((hdd) => {
                        return {
                            vueJSUniqueID: this.randomID(),
                            hotelDate: hdd,
                            base: 0,
                            taxes: 0,
                            total: 0,
                            baseWarning: false,
                            personalDay: false,
                            exception: false,
                            exceptions: [],
                            exceptionSatisfied: false
                        }
                    })
                   // let unionedDates = _.unionBy(hotel.hotelDayDates, calculatedDates, 'hotelDate')
                    //order by hotel date so pushed item is not at end
                    let orderedDates = _.orderBy(calculatedDates, 'hotelDate')
                    let m = this.moment;
                    hotel.hotelDayDates = orderedDates.filter((hotelDate,idx) => {
                        let hotelDateFormatted = DateService.normalizeDateTime(hotelDate.hotelDate)
                        let endDateFormatted = DateService.normalizeDateTime(endDate)
                        let startDateFormatted = DateService.normalizeDateTime(startDate)
                        if (this.referenceDates[idx].personal && orderedDates.length == idx + 1)
                            return true;
                        return hotelDateFormatted.isSameOrAfter(startDateFormatted, 'day') && hotelDateFormatted.isBefore(endDateFormatted, 'day');
                    })
                    hotel.hotelDayDates.forEach(d => d.hotelDate = DateService.normalizeDateTime(d.hotelDate))
                    hotel.hotelDayDates.forEach(hd => this.updateHotelDay(hotel, hd));
                }

            },
            randomID() {
                return '_' + Math.random().toString(36).substr(2, 9);
            },
            addHotel() {
                this.hotels.push({
                    hotelName: null,
                    attachments: [],
                    startDate: null,
                    endDate: null,
                    hotelDayDates: [],
                    subTotal: 0,
                    total: 0
                })
            },
            total(num, num2) {
                if (num && num2) {
                    return num + num2;
                }
                else {
                    return 0;
                }
            },
            async saveHotel() {
                let isSuccess = false;
                if (this.isValid()) {
                    let lodgeRequest = this.createLodgeRequest()
                    this.$data.hash = JSON.stringify(lodgeRequest);
                    try {
                        let lodgeResponse = await LodgeService.saveLodge(lodgeRequest)
                        this.expenseReportID = lodgeResponse.expenseReportId;
                        this.hotels = [];
                        this.lodging = lodgeResponse;
                        this.hotels = LodgeService.mapResponseToHotel(this.lodging.lodges,true);
                        //foreach hotel, foreach hotel day, run updates
                        this.updateAllHotelAllDays();
                        this.$refs.nav.getSummaryCosts();
                        this.$notify({ group: 'success', type: 'success ', title: 'Success', text: "Lodging saved successfully" });
                        isSuccess = true;
                        window.scrollTo(0, 0);
                        await this.$refs.validationAlert.revalidate();
                    } catch (e) {
                        this.$notify({ group: 'errors', type: 'error', title: 'Error', text: e });
                    }
                }

                return isSuccess;
            },
            updateAllHotelAllDays() {
                console.log('LodgingView.Methods.updateAllHotelAllDays')
                this.hotels.forEach((h => {
                    //remove execption 
                    h.hotelDayDates.forEach((hdd => {
                        this.updateHotelDay(h, hdd);
                    }))
                }))
            }
        },
        async beforeRouteLeave(to, from, next) {
            if (this.expenseReportStatusTypeId > 1) {
                next()
            }
            else {

                this.navNext = next;

                if (this.$data.hash !== this.hashData) {
                    this.show_modal = true;
                }
                else {
                    console.log("Data has not changed");
                    next();
                }          
            }
        }
    }
</script>

<style scoped>
    .copypreviousday {
        font-weight: 100;
        min-width: 150px;
    }

    .offday {
        background-color: #eeefe9;
    }

    .total {
        font-weight: bold;
    }

    .errortext {
        color: red;
        font-weight: 700;
    }

    .btn-text-white {
        color: white !important
    }

    .remove-input-border {
        border: none;
    }

    /*new styling from Maui 03/2020 */

    .table th, .table td {
        text-align: center;
    }


    /*input {
        text-align: center;
    }*/

    .td-updated {
        outline: 1px solid;
        padding-left: 5px;
        padding-right: 5px;
    }

    .td-updated input {
        text-align: center;
    }

    .personalText {
        display: none;
    }

    .showPersonalText {
        display: initial;
    }

    input.remove-input-border {
        width: 100%;
    }

    input:focus, textarea:focus, select:focus {
        outline: none;
    }

    .right-span {
        margin-right:5px;
    }

    .top-bottom-margin {
        margin: 5px
    }

    .warning-span-info {
        font-weight: bolder;
    }

    /*Remove updown arrows on input */
    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    /* Firefox */
    input[type=number] {
        -moz-appearance: textfield;
    }

    /*end new styling*/

</style>